import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Layout from '../../containers/Layout';
import SettingsDrawer from './components/SettingsDrawer';
import OrganizationsList from './containers/OrganizationsList';
import OrganizationDetail from './containers/OrganizationDetail';
export const defaultUrl = '/organizations';
class SettingsOrganizationsPage extends Component {
    render() {
        const { user, match, t } = this.props;
        return (_jsx(Layout, { title: t('settings.organizations'), loginRequired: true, withDrawer: true, match: match, loading: !user.user, titlePrimary: t('settings.settings'), children: _jsx("div", { className: "container repository-detail__container", children: _jsxs("div", { className: "row", children: [_jsx(SettingsDrawer, { className: "col col-12 col-md-2" }), _jsxs("div", { className: "col col-12 col-md-10 repository-detail__content", children: [_jsx("h2", { className: "repository-detail__title mb-1", children: t('settings.organizations') }), _jsxs(Switch, { children: [_jsx(Route, { path: `${match.url}/:name`, component: OrganizationDetail }), _jsx(Route, { component: OrganizationsList })] })] })] }) }) }));
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
});
// const mapDispatchToProps = dispatch => ({
// 	dispatch: dispatch,
// });
export default connect(mapStateToProps /*, mapDispatchToProps*/)(withTranslation()(SettingsOrganizationsPage));
